/**
 * Shared constants. Anything the admin can change at runtime lives in the
 * server's Setting table and is pushed to clients through `state:sync.config`;
 * the values here are the defaults and the hard bounds.
 */
export const ROUND_PHASES = ["IDLE", "BETTING", "FLYING", "CRASHED", "RESOLVING"];
export const RENDER_MODES = ["plane", "rocket", "graph"];
export const PF_MODES = ["chain", "players"];
export const EDGE_MODES = ["scaled", "instant"];
export const LICENSE_TIERS = ["regular", "extended", "review"];
export const BET_PANELS = ["A", "B"];
export const GAME_DEFAULTS = {
    /** Multiplier growth constant per millisecond: m(t) = e^(k·t). 1e-4 → 2x in ≈6.9 s, 10x in ≈23 s. */
    growthK: 0.0001,
    /** 0.03 → theoretical RTP ≈ 97 %. */
    houseEdge: 0.03,
    edgeMode: "scaled",
    pfMode: "chain",
    maxMultiplier: 1000,
    bettingMs: 5000,
    crashPauseMs: 3000,
    /** Server-side grace applied to cashout timestamps (0–100 ms). */
    cashoutToleranceMs: 0,
    /** Broadcast cadence of `round:tick` (clock re-sync), ms. */
    tickMs: 500,
    /** Bets/cashouts are batched before broadcast, ms. */
    broadcastBatchMs: 100,
    minBet: 0.1,
    maxBet: 1000,
    maxWinPerRound: 100000,
    historyLength: 30,
    /** Multiplier value at which the history badge colour changes. */
    historyTiers: { mid: 2, high: 10 },
};
export const GAME_BOUNDS = {
    growthK: { min: 0.00002, max: 0.0003 },
    houseEdge: { min: 0.01, max: 0.1 },
    maxMultiplier: { min: 10, max: 1_000_000 },
    bettingMs: { min: 3000, max: 10000 },
    crashPauseMs: { min: 2000, max: 5000 },
    cashoutToleranceMs: { min: 0, max: 100 },
};
/** ISO 4217-like codes used by the ledger. `USD` is the internal credit / FUN currency. */
export const CURRENCY_CODE_REGEX = /^[A-Z0-9]{2,10}$/;
export const HEX_REGEX = /^[0-9a-f]+$/;
export const SHA256_HEX_REGEX = /^[0-9a-f]{64}$/;
export const SHA512_HEX_REGEX = /^[0-9a-f]{128}$/;
//# sourceMappingURL=constants.js.map